export default __webpack_public_path__ + "static/media/khalif.8e53721a.jpg";